<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Regla de Tarifas</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link
        @click="_guardarReglaTarifa(false)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
      </v-chip>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarReglaTarifa(true)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Guardar y Cerrar</span>
      </v-chip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>
        <v-col class="ml-0">
          <v-row dense class="mx-4">

            <v-select v-model="modelReglaTarifa.nombre" :items="temporadas" item-text="label" item-value="value"
              outlined dense label="Selecciona nombre de la temporada" @change="_changeTemporada">
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center">
                  <v-chip label :color="item.color" class="mr-2" small></v-chip>
                  <span>{{ item.label }}</span>
                </div>
              </template>
            </v-select>



            <!--    <v-text-field v-model="modelReglaTarifa.nombre" outlined label="Nombre" dense :dark="dark"
              autocomplete="off"></v-text-field>
              -->


          </v-row>

          <v-row dense class="mx-4">
            <v-col>
              <v-menu :dark="dark" v-model="showFechaDesde" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ attrs }">
                  <v-text-field :dark="dark" class="mr-2" clearable dense outlined
                    v-bind="attrs" v-model="fechaDesdeInput" label="Fecha desde (DD/MM/YYYY)"
                    prepend-inner-icon="mdi-calendar"
                    :error="fechaDesdeInvalida"
                    :error-messages="fechaDesdeInvalida ? ['Fecha inválida'] : []"
                    :hide-details="!fechaDesdeInvalida"
                    @input="_onFechaDesdeInput"
                    @click:prepend-inner="showFechaDesde = true"
                    @blur="_applyFechaDesdeInput"
                    @keydown.enter.prevent="_applyFechaDesdeInput"
                    @click:clear="_clearFechaDesde"></v-text-field>
                </template>
                <v-date-picker :dark="dark" color="success" locale="es" v-model="modelReglaTarifa.fecha_desde"
                  @input="showFechaDesde = false" @change="_changeFechaDesde()" first-day-of-week="1"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col>
              <v-menu :dark="dark" v-model="showFechaHasta" :close-on-content-click="false" :nudge-right="40"
                transition="scale-transition" offset-y min-width="290px">
                <template v-slot:activator="{ attrs }">
                  <v-text-field class="ml-2" :dark="dark" clearable dense outlined
                    v-bind="attrs" v-model="fechaHastaInput" label="Fecha hasta (DD/MM/YYYY)"
                    prepend-inner-icon="mdi-calendar"
                    :error="fechaHastaInvalida"
                    :error-messages="fechaHastaInvalida ? ['Fecha inválida'] : []"
                    :hide-details="!fechaHastaInvalida"
                    @input="_onFechaHastaInput"
                    @click:prepend-inner="showFechaHasta = true"
                    @blur="_applyFechaHastaInput"
                    @keydown.enter.prevent="_applyFechaHastaInput"
                    @click:clear="_clearFechaHasta"></v-text-field>
                </template>
                <v-date-picker :dark="dark" color="success" locale="es" v-model="modelReglaTarifa.fecha_hasta"
                  @input="showFechaHasta = false" first-day-of-week="1" @change="_changeFechaHasta()"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>




          <v-row dense class="mx-4 mb-4 mt-12">
            <v-col cols="12" md="6" class="pa-0 pr-md-4">
              <h3>Seleccione los días de la semana en los que se aplicará la regla de tarifas.</h3>

              <v-radio-group v-model="tipoDiasSemanaSeleccionado" @change="_seleccionarTipoDiaSemana">
                <v-radio v-for="tipo in tiposDiasSemanas" return-object :key="tipo.label" :label="tipo.label"
                  :value="tipo" class="mb-2"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="12" md="6" class="pa-0 pl-md-4">
              <h3>O seleccione días concretos.</h3>

              <v-select
                v-model="diasSemanaSeleccionados"
                :items="diasSemanaIndividuales"
                item-text="label"
                item-value="value"
                label="Días concretos"
                multiple
                chips
                small-chips
                outlined
                dense
                clearable
                @change="_seleccionarDiasConcretos"
              ></v-select>
            </v-col>
          </v-row>



        </v-col>

        <v-divider vertical></v-divider>

        <v-col class="ml-0">

          <v-data-table locale="es" dense :headers="headersTarifas" :items="tarifasConPrecio"
            :items-per-page="tarifasConPrecio.length" class="elevation-1 alternating-rows bordered-table mx-4 mb-6"
            hide-default-footer>
            <template v-slot:top>
              <v-toolbar dense :color="colorBarraFormulario" dark flat>
                <v-toolbar-title>Tarifas disponibles</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>

            <template v-slot:item.precio="{ item }">
              <v-text-field :disabled="tarifasDeshabilitadas" class="mt-2 mb-2 text-right" v-model="item.precio"
                outlined dense hide-details></v-text-field>
            </template>

            <template v-slot:no-data>
              No hay tarifas disponibles
            </template>

          </v-data-table>

        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "ReglaFormulario",
  components: {},
  data: () => ({
    loading: false,
    tarifasDeshabilitadas: false,

    showFechaDesde: false,
    showFechaHasta: false,
    fechaDesdeInput: "",
    fechaHastaInput: "",
    fechaDesdeInvalida: false,
    fechaHastaInvalida: false,

    tarifasConPrecio: [],

    tiposDiasSemanas: [{
      label: "Todos los días",
      dia_desde: 0,
      dia_hasta: 6,
    },
    {
      label: "De Lunes a Jueves",
      dia_desde: 1,
      dia_hasta: 4,
    },
    {
      label: "De Lunes a Viernes",
      dia_desde: 1,
      dia_hasta: 5,
    },
    {
      label: "Sábados y Domingos",
      dia_desde: 6,
      dia_hasta: 0,
    },
    {
      label: "Viernes, Sabados y Domingos",
      dia_desde: 5,
      dia_hasta: 0,
    }],

    diasSemanaIndividuales: [
      { label: "Lunes", value: 1 },
      { label: "Martes", value: 2 },
      { label: "Miércoles", value: 3 },
      { label: "Jueves", value: 4 },
      { label: "Viernes", value: 5 },
      { label: "Sábado", value: 6 },
      { label: "Domingo", value: 7 },
    ],

    tipoDiasSemanaSeleccionado: {
      label: "Todos los días",
      dia_desde: 0,
      dia_hasta: 6,
    },

    diasSemanaSeleccionados: [],

    headersTarifas: [
      { text: 'REGIMEN', value: 'regimen_titulo' },
      { text: 'HABITACION-CARACTERISTICA', value: 'habitacion_caracteristica_titulo' },
      { text: 'PRECIO', value: 'precio', width: '200px' },
    ],

    temporadaSeleccionada: null,
    temporadas: [
      { label: "Temporada Baja", value: "Temporada Baja", color: "green" },
      { label: "Temporada Media", value: "Temporada Media", color: "blue" },
      { label: "Temporada Alta", value: "Temporada Alta", color: "orange" },
      { label: "Temporada Especial", value: "Temporada Especial", color: "yellow" },
      { label: "Temporada Única", value: "Temporada Única", color: "purple" },
      { label: "Cierre", value: "Cierre", color: "red" },
    ],

  }),

  props: {
    modelReglaTarifa: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorFondoDialog",
      "colorBarraFormulario",
      "tiposCliente",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("proveedores", [
      "proveedorSelec"
    ]),
  },



  mounted() {
    this._inicializarDatos();
  },

  watch: {
    modelReglaTarifa(newVal) {
      this._inicializarDatos();
    }
  },

  methods: {
    ...mapActions("reglas", ["crearRegla", "updateRegla", "getReglasFromProveedor"]),

    _inicializarDatos() {
      if (this.accion == "crear") {
        this.tarifasConPrecio = this.proveedorSelec.tarifas;
      } else if (this.accion == "editar") {
        this.tarifasConPrecio = this.modelReglaTarifa.tarifas;
      } else if (this.accion == "duplicar") {
        this.tarifasConPrecio = this.modelReglaTarifa.tarifas;
      }
      this._sincronizarFechasInput();
      this._actualizarDatosDiaSemana();
    },

    _actualizarDatosDiaSemana() {
      const diasSemana = this._normalizarDiasSemana(this.modelReglaTarifa.dias_semana);

      if (this.accion == "editar" || this.accion == "duplicar") {
        if (diasSemana.length > 0) {
          this.tipoDiasSemanaSeleccionado = null;
          this.diasSemanaSeleccionados = diasSemana;
          return;
        }

        const tipoSeleccionado = this.tiposDiasSemanas.find(tipo => tipo.dia_desde === this.modelReglaTarifa.dia_desde && tipo.dia_hasta === this.modelReglaTarifa.dia_hasta);
        this.tipoDiasSemanaSeleccionado = tipoSeleccionado || null;
        this.diasSemanaSeleccionados = this.modelReglaTarifa.dia_desde === this.modelReglaTarifa.dia_hasta
          ? [this._normalizarDiaSemanaParaArray(this.modelReglaTarifa.dia_desde)]
          : [];
      } else {
        this.tipoDiasSemanaSeleccionado = {
          label: "Todos los días",
          dia_desde: 0,
          dia_hasta: 6,
        };
        this.diasSemanaSeleccionados = [];
      }
    },

    _seleccionarTipoDiaSemana(tipo) {
      if (!tipo) {
        return;
      }
      this.diasSemanaSeleccionados = [];
      this.modelReglaTarifa.dias_semana = [];
      this.modelReglaTarifa.dia_desde = tipo.dia_desde;
      this.modelReglaTarifa.dia_hasta = tipo.dia_hasta;
    },

    _seleccionarDiasConcretos(dias) {
      const diasNormalizados = this._normalizarDiasSemana(dias);
      this.diasSemanaSeleccionados = diasNormalizados;

      if (diasNormalizados.length > 0) {
        this.tipoDiasSemanaSeleccionado = null;
        this.modelReglaTarifa.dias_semana = diasNormalizados;
        this.modelReglaTarifa.dia_desde = null;
        this.modelReglaTarifa.dia_hasta = null;
        return;
      }

      if (!this.tipoDiasSemanaSeleccionado) {
        this.tipoDiasSemanaSeleccionado = this.tiposDiasSemanas[0];
      }

      this.modelReglaTarifa.dias_semana = [];
      this.modelReglaTarifa.dia_desde = this.tipoDiasSemanaSeleccionado.dia_desde;
      this.modelReglaTarifa.dia_hasta = this.tipoDiasSemanaSeleccionado.dia_hasta;
    },

    _reiniciarTarifas() {
      this.tarifasConPrecio.forEach(tarifa => {
        tarifa.precio = 0;
      });
    },


    _changeTemporada(item) {
      if (item == "Cierre") {
        this._reiniciarTarifas();
        this.tarifasDeshabilitadas = true;
      } else {
        this.tarifasDeshabilitadas = false;
      }
    },


    _changeFechaDesde() {
      this.fechaDesdeInput = this._toDisplayDate(this.modelReglaTarifa.fecha_desde);
      this.fechaDesdeInvalida = false;
    },

    _changeFechaHasta() {
      this.fechaHastaInput = this._toDisplayDate(this.modelReglaTarifa.fecha_hasta);
      this.fechaHastaInvalida = false;
    },

    _sincronizarFechasInput() {
      this.fechaDesdeInput = this._toDisplayDate(this.modelReglaTarifa.fecha_desde);
      this.fechaHastaInput = this._toDisplayDate(this.modelReglaTarifa.fecha_hasta);
      this.fechaDesdeInvalida = false;
      this.fechaHastaInvalida = false;
    },

    _onFechaDesdeInput(value) {
      this.fechaDesdeInvalida = false;
      if (!value) return;
      this.fechaDesdeInvalida = this._isFechaInvalida(value);
    },

    _onFechaHastaInput(value) {
      this.fechaHastaInvalida = false;
      if (!value) return;
      this.fechaHastaInvalida = this._isFechaInvalida(value);
    },

    _isFechaInvalida(value) {
      const raw = (value || "").trim();
      if (!raw) return false;

      const isDisplay = /^\d{2}\/\d{2}\/\d{4}$/.test(raw);
      const isCompact = /^\d{8}$/.test(raw);
      const isIso = /^\d{4}-\d{2}-\d{2}$/.test(raw);

      if (!isDisplay && !isCompact && !isIso) return false;
      return !this._toIsoDate(raw);
    },

    _applyFechaDesdeInput() {
      if (!this.fechaDesdeInput) {
        this.modelReglaTarifa.fecha_desde = null;
        this.fechaDesdeInvalida = false;
        return;
      }
      const isoDate = this._toIsoDate(this.fechaDesdeInput);
      if (isoDate) {
        this.modelReglaTarifa.fecha_desde = isoDate;
        this.fechaDesdeInput = this._toDisplayDate(isoDate);
        this.fechaDesdeInvalida = false;
      } else {
        this.modelReglaTarifa.fecha_desde = null;
        this.fechaDesdeInvalida = true;
      }
    },

    _applyFechaHastaInput() {
      if (!this.fechaHastaInput) {
        this.modelReglaTarifa.fecha_hasta = null;
        this.fechaHastaInvalida = false;
        return;
      }
      const isoDate = this._toIsoDate(this.fechaHastaInput);
      if (isoDate) {
        this.modelReglaTarifa.fecha_hasta = isoDate;
        this.fechaHastaInput = this._toDisplayDate(isoDate);
        this.fechaHastaInvalida = false;
      } else {
        this.modelReglaTarifa.fecha_hasta = null;
        this.fechaHastaInvalida = true;
      }
    },

    _clearFechaDesde() {
      this.fechaDesdeInput = "";
      this.modelReglaTarifa.fecha_desde = null;
      this.fechaDesdeInvalida = false;
    },

    _clearFechaHasta() {
      this.fechaHastaInput = "";
      this.modelReglaTarifa.fecha_hasta = null;
      this.fechaHastaInvalida = false;
    },

    _toDisplayDate(value) {
      if (!value) return "";
      const isoMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (isoMatch) {
        return `${isoMatch[3]}/${isoMatch[2]}/${isoMatch[1]}`;
      }
      const displayMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (displayMatch) {
        return value;
      }
      return "";
    },

    _toIsoDate(value) {
      const raw = (value || "").trim();
      if (!raw) return null;

      let day = "";
      let month = "";
      let year = "";

      const displayMatch = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      const compactMatch = raw.match(/^(\d{2})(\d{2})(\d{4})$/);

      if (displayMatch) {
        day = displayMatch[1];
        month = displayMatch[2];
        year = displayMatch[3];
      } else if (isoMatch) {
        year = isoMatch[1];
        month = isoMatch[2];
        day = isoMatch[3];
      } else if (compactMatch) {
        day = compactMatch[1];
        month = compactMatch[2];
        year = compactMatch[3];
      } else {
        return null;
      }

      const parsedDay = parseInt(day, 10);
      const parsedMonth = parseInt(month, 10);
      const parsedYear = parseInt(year, 10);
      const date = new Date(parsedYear, parsedMonth - 1, parsedDay);

      if (
        date.getFullYear() !== parsedYear ||
        date.getMonth() !== parsedMonth - 1 ||
        date.getDate() !== parsedDay
      ) {
        return null;
      }

      return `${year}-${month}-${day}`;
    },

    _normalizarDiaSemanaParaArray(dia) {
      const diaNumero = Number(dia);

      if (Number.isNaN(diaNumero)) {
        return null;
      }

      if (diaNumero === 0) {
        return 7;
      }

      return diaNumero;
    },

    _normalizarDiasSemana(dias) {
      if (!Array.isArray(dias)) {
        return [];
      }

      return [...new Set(
        dias
          .map(dia => this._normalizarDiaSemanaParaArray(dia))
          .filter(dia => dia >= 1 && dia <= 7)
      )].sort((a, b) => a - b);
    },

    _cerrarVentana() {
      this.$emit("cerrarFormularioReglaTarifa");
    },

    async _guardarReglaTarifa(cerrar) {
      if (this.diasSemanaSeleccionados.length > 0) {
        this.modelReglaTarifa.dias_semana = this._normalizarDiasSemana(this.diasSemanaSeleccionados);
        this.modelReglaTarifa.dia_desde = null;
        this.modelReglaTarifa.dia_hasta = null;
      } else if (this.tipoDiasSemanaSeleccionado != null) {
        this.modelReglaTarifa.dias_semana = [];
        this.modelReglaTarifa.dia_desde = this.tipoDiasSemanaSeleccionado.dia_desde;
        this.modelReglaTarifa.dia_hasta = this.tipoDiasSemanaSeleccionado.dia_hasta;
      } else {
        this.modelReglaTarifa.dias_semana = [];
        this.modelReglaTarifa.dia_desde = 0;
        this.modelReglaTarifa.dia_hasta = 6;
      }
      let mTarifasReglas = [];
      for (let i = 0; i < this.tarifasConPrecio.length; i++) {
        let mTarifaRegla = {
          tarifa_id: this.tarifasConPrecio[i].id,
          precio: parseFloat(this.tarifasConPrecio[i].precio.toString().replace(/,/g, '.')),
        }
        mTarifasReglas.push(mTarifaRegla);
      }
      this.loading = true;
      if (this.accion == "crear" || this.accion == "duplicar") {
        var res = await this.crearRegla([
          this.access_token,
          this.modelReglaTarifa,
          mTarifasReglas,
        ]);

      } else if (this.accion == "editar") {
        var res = await this.updateRegla([
          this.access_token,
          this.modelReglaTarifa,
          mTarifasReglas,
        ]);

      }
      if (cerrar) {
        this._cerrarVentana();
        await this.getReglasFromProveedor([this.access_token, this.proveedorSelec.id, true]);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
  /* Alineación a la derecha */
}
</style>
